import React from "react";
import { Link } from "@quintype/components";
import { object } from "prop-types";

import CollectionTitleWithArrow from "../../../atoms/CollectionTitleWithArrow";
import NewsHeadline from "../../../atoms/NewsHeadline";
import ButtonOutline from "../../../atoms/ButtonOutline";
import SponsorDetails from "../../../molecules/SponsorDetails";
import SponsoredIcon from "../../../atoms/icons/Sponsored";

import "./organism1.m.css";

const Organism1 = ({ collection }) => {
  const { story = {} } = collection.items[0];

  const sponsorId = story.metadata?.["story-attributes"]?.sponsoredby?.[0]?.id || null;
  const sponsor = sponsorId && story["story-template"] !== "live-blog";

  const tag = story.tags?.[0] || {};

  return (
    <div styleName="wrapper" className="full-screen-content">
      {sponsor ? (
        <div styleName="sponsor-wrapper">
          <SponsoredIcon styleName="sponsor-icon" />
          <SponsorDetails sponsorId={sponsorId} showImage={false} />
        </div>
      ) : (
        <CollectionTitleWithArrow collection={collection} disableArrow className="collection-title-wrapper" />
      )}

      <div>
        <NewsHeadline story={story} showSubHeading={false} showSponsor={false} />
        <Link aria-label={tag.slug} href={"/topic/" + tag.slug} styleName="tag">
          {tag.name}
        </Link>
        <ButtonOutline story={story} />
      </div>
    </div>
  );
};

Organism1.propTypes = {
  collection: object,
};

export default Organism1;
